import * as React from 'react';

export const InputFileDefProps = {
  label: <div>Input File</div>,
  id: 'inputFileId',
  onInputFileChange: () => {}
};